<template>
  <div>
    <UndoButton ref="undo" @pop="popHandler" />
  </div>
</template>

<script>
import UndoButton from '@/components/Shared/Button/UndoButton'

export default {
  name: 'AppUndoButton',
  components: {
    UndoButton,
  },
  props: {
    name: String,
  },
  mounted() {
    // 初回 state を push
    this.$refs.undo.initialize(this.name)
  },
  methods: {
    push(newName) {
      this.$refs.undo.push(newName)
    },
    popHandler(oldName) {
      // カスタムイベントを伝播させる
      this.$emit('pop', oldName)
    },
  },
}
</script>

<style scoped></style>
